import { PageToolbar } from '../../../../ui/components/PageToolbar';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import React from 'react';
export function TotalPendingHoursToolbar({ title, count, showingPendingOnly = false, onChange, children }) {
    const { t } = useMissionsTranslation();
    return (React.createElement(PageToolbar, { title: title, showTitle: true, count: count },
        React.createElement(FormControlLabel, { sx: { mr: 0 }, control: React.createElement(Switch, { checked: showingPendingOnly, onChange: onChange, inputProps: { 'aria-label': t('shifts.ariaLabels.pendingShiftsHoursSwitch') } }), label: React.createElement(Typography, { variant: 'body2' }, t('shifts.showPendingOnly')), "data-test": 'shifts-with-pending-hours-switch' }),
        children));
}
